import ImportModal from "pages/PanelPage/components/selectedAssessment/assessmentInvite/ImportModal/ImportModal";

export default ImportModal;
